import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { customerActions } from '../../modules/Actions';
import { UserState, UserInfo } from '@common/redux/reducers/UserReducer';

export type CustomerUserState = UserState

export const initialState: CustomerUserState = {
  crewCd: '11111111',
  crewName: 'ログイン太郎',
  browsableStores: ['FF000001'],
  isLoggedIn: false
};

export const UserReducer = reducerWithInitialState(initialState).case(
  customerActions.loginUser.updateUser,
  (state: CustomerUserState, payload: UserInfo) => {
    return {
      ...payload,
      isLoggedIn: state.isLoggedIn
    };
  }
).case(
  customerActions.updateLogInStatus,
  (state: CustomerUserState, payload: boolean) => {
    return {
      ...state,
      isLoggedIn: payload
    };
  }
);
